var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotCompletedV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7189 8.83871C23.3117 9.18729 23.5097 9.95047 23.1612 10.5433L16.002 22.7192C15.7913 23.0777 15.4155 23.3073 15.0004 23.3312C14.5853 23.3552 14.1856 23.1704 13.9349 22.8386L8.9182 16.1972C8.50367 15.6485 8.61249 14.8675 9.16126 14.453C9.71003 14.0385 10.4909 14.1473 10.9055 14.6961L14.7994 19.851L21.0143 9.281C21.3628 8.68814 22.126 8.49012 22.7189 8.83871Z",
    fill: "#1D1B18"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotCompletedV);
export default __webpack_public_path__ + "static/media/Bot_Completed_V.71b433dc345573d674c36362198731e2.svg";
export { ForwardRef as ReactComponent };